import { motion } from "framer-motion";
import { MathRichText } from "@/lib/mathRichText";

interface Props {
  data: {
    type: "comparison_table";
    title?: string;
    headers: string[];
    rows: string[][];
    animation?: string;
  };
}

export function ElementComparisonTable({ data }: Props) {
  const headers = data.headers ?? [];
  const rows = data.rows ?? [];
  return (
    <motion.div
      className="overflow-x-auto rounded-lg border border-slate-200 bg-white"
      initial={{ opacity: 0, x: 16 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3 }}
    >
      {data.title && <p className="font-semibold px-3 py-2 text-slate-800 border-b">{data.title}</p>}
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-slate-100">
            {headers.map((h, i) => (
              <th key={i} className="px-3 py-2 text-left font-semibold text-slate-700 border-b">
                <MathRichText text={h} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, ri) => (
            <tr key={ri} className="border-b border-slate-100 last:border-0">
              {(row ?? []).map((cell, ci) => (
                <td key={ci} className="px-3 py-2 text-slate-700">
                  <MathRichText text={cell} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </motion.div>
  );
}
